import { Component, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';

@Component({
    selector: 'tea-shop-fe-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent {
  private metaDataService = inject(MetaDataService);


  constructor() { 
    this.metaDataService.updateMetadata({
      title: 'Privacy Policy',
      image: '/assets/contact/sencha-logo.png',
    });
  }
}
